<template>
	<div class="video-player-container">
		<div title="Back">
			<img src="@/assets/img/back button.svg" alt="" @click="handleBack" class="backBtn" />
		</div>
		<div title="Play on TV">
			<img src="@/assets/img/cast.svg" alt="" @click="ShowCastNotification" class="cast-btn" />
		</div>
		<video id="vid1" preload="auto" class="video-js vjs-default-skin safari-player" controls></video>
	</div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-contrib-eme";
import Castjs from "@/assets/js/Cast.js";
import("videojs-hls-quality-selector");
export default {
	name: "SafariPlayer",
	props: ["safariPlayback", "customData", "playback"],

	data() {
		return {
			showCastVideoNotification: false,
		};
	},
	mounted() {
		var options = {
			controlBar: {
				volumePanel: {
					inline: false,
					vertical: true,
				},
			},
		};
		var player = videojs("vid1", options, () => {
			player.hlsQualitySelector({
				displayCurrentQuality: true,
			});
		});

		var license = "https://lic.drmtoday.com/license-server-fairplay/";
		var cert = "https://lic.drmtoday.com/license-server-fairplay/cert/ibakatv";
		var stream = this.safariPlayback;
		player.eme();
		player.src({
			src: stream,
			type: "application/x-mpegURL",
			keySystems: {
				"com.apple.fps.1_0": {
					getCertificate: (emeOptions, callback) => {
						videojs.xhr(
							{
								url:
									"https://lic.drmtoday.com/license-server-fairplay/cert/ibakatv",
								method: "GET",
								responseType: "arraybuffer",
								headers: {
									Pragma: "no-cache",
									"Cache-Control": "no-cache",
									"Content-Type": "text/xml; charset=utf-8",
								},
							},
							(err, response, responseBody) => {
								if (err) {
									callback(err);
									return;
								}
								callback(null, new Uint8Array(responseBody));
							}
						);
					},
					getContentId: (emeOptions, contentId) => {
						// return content ID
						var hostname = this.Utf8ArrayToStr(contentId);
						// hostname = hostname.replace(null,'')
						hostname = hostname
							.split("")
							.filter((char) => char.codePointAt(0))
							.join("");

						hostname = hostname.replace("skd://drmtoday?", "");
						return encodeURI(hostname);
					},

					getLicense: (emeOptions, contentId, keyMessage, callback) => {
						let spcMessage = btoa(String.fromCharCode.apply(null, keyMessage))
							.replace(/\+/g, "-")
							.replace(/\//g, "_")
							.replace(/=*$/, "");
						let postString = "spc=" + spcMessage + "&" + contentId;
						videojs.xhr(
							{
								url: "https://lic.drmtoday.com/license-server-fairplay/",
								method: "POST",
								responseType: "text",
								body: postString,
								headers: {
									"Content-type": "application/x-www-form-urlencoded",
									"x-dt-custom-data": this.customData,
								},
							},
							(err, response, responseBody) => {
								if (err) {
									callback(err);
									return;
								}
								callback(null, this.base64DecodeUint8Array(responseBody));
							}
						);
					},
				},
			},
		});
		document.addEventListener("fullscreenchange", this.handleFullscreenOrientation);
		player.on("play", () => {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in the cast device"
				);
			}
			let fullscreenOrNot = this.player.isFullscreen();
			if (fullscreenOrNot) {
				screen.orientation.lock("landscape");
			}
			else {
				screen.orientation.lock("portrait");
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.play();
			}
		});

		player.on("pause", () => {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in the cast device"
				);
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.pause();
			}
		});

		player.on("seeked", () => {
			let playerCurrentTime = Math.floor(player.currentTime());
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.seek(playerCurrentTime);
			}
		});
		player.on("volumechange", () => {
			let playerCurrentVolumeTime = player.volume();
			if (player.muted) {
				let cjs = this.$store.getters.getCjs;
				if (cjs != null) {
					cjs.mute();
				}
			}
			if (!player.muted) {
				let cjs = this.$store.getters.getCjs;
				if (cjs != null) {
					cjs.unmute();
				}
			}
			let cjs = this.$store.getters.getCjs;
			if (cjs != null) {
				cjs.volume(playerCurrentVolumeTime);
			}
		});
		const isCastingOn = this.$store.getters.getIsCastingOn;
		if (isCastingOn) {
			this.loadDefaultCast();
		}
		let qualityLevels = player.qualityLevels();
		//console.log("qualityLevels", qualityLevels);
	},

	methods: {
		handleBack() {
			history.back();
		},
		base64DecodeUint8Array(input) {
			var raw = window.atob(input);
			var rawLength = raw.length;
			var array = new Uint8Array(new ArrayBuffer(rawLength));

			for (i = 0; i < rawLength; i++) array[i] = raw.charCodeAt(i);

			return array;
		},

		base64EncodeUint8Array(input) {
			var keyStr =
				"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
			var output = "";
			var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
			var i = 0;

			while (i < input.length) {
				chr1 = input[i++];
				chr2 = i < input.length ? input[i++] : Number.NaN;
				chr3 = i < input.length ? input[i++] : Number.NaN;

				enc1 = chr1 >> 2;
				enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
				enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
				enc4 = chr3 & 63;

				if (isNaN(chr2)) {
					enc3 = enc4 = 64;
				} else if (isNaN(chr3)) {
					enc4 = 64;
				}
				output +=
					keyStr.charAt(enc1) +
					keyStr.charAt(enc2) +
					keyStr.charAt(enc3) +
					keyStr.charAt(enc4);
			}
			return output;
		},
		Utf8ArrayToStr(array) {
			var out, i, len, c;
			var char2, char3;

			out = "";
			len = array.length;
			i = 0;
			while (i < len) {
				c = array[i++];
				switch (c >> 4) {
					case 0:
					case 1:
					case 2:
					case 3:
					case 4:
					case 5:
					case 6:
					case 7:
						// 0xxxxxxx
						out += String.fromCharCode(c);
						break;
					case 12:
					case 13:
						// 110x xxxx   10xx xxxx
						char2 = array[i++];
						out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
						break;
					case 14:
						// 1110 xxxx  10xx xxxx  10xx xxxx
						char2 = array[i++];
						char3 = array[i++];
						out += String.fromCharCode(
							((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
						);
						break;
				}
			}

			return out;
		},
		sendRemotePlayer() {
			let cjs = this.$store.getters.getCjs;
			if (cjs == null) {
				cjs = new Castjs({
					receiver: "A32C4740",
				});
				this.$store.commit("setCjs", cjs);
			}
			cjs.on("connect", () => {
				this.$store.commit("setNotification", `Connected to ${cjs.device}`);
				this.$store.commit("setIsCastingOn", true);
				player.pause();
				this.showCastVideoNotification = true;
			});
			if (cjs.available) {
				cjs.cast(this.playback, {}, { licenseHeader: this.customData });
			}
			cjs.on("playing", () => {
				let playerCurrentTime = Math.floor(player.currentTime());
				if (cjs != null) {
					cjs.seek(playerCurrentTime);
				}
			});
			cjs.on("disconnect", () => {
				this.$store.commit(
					"setNotification",
					`DisConnected from ${cjs.device}`
				);
				this.$store.commit("setIsCastingOn", false);
				this.showCastVideoNotification = false;
			});
		},
		castNotification() {
			if (this.showCastVideoNotification) {
				this.$store.commit(
					"setNotification",
					"Video is also playing in cast device"
				);
			}
		},
		loadDefaultCast() {
			var mediaInfo = new chrome.cast.media.MediaInfo(this.playback);
			mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
			this.version = "v4.1.2";
			//	this.receiver = opt.receiver;
			//	this.joinpolicy = opt.joinpolicy;
			//	this.available = false;
			//this.connected = false;
			this.device = "Chromecast";
			this.src = "";
			this.title = "";
			this.description = "";
			this.poster = "";
			this.subtitles = [];
			this.volumeLevel = 1;
			this.muted = false;
			this.paused = false;
			this.time = 0;
			this.timePretty = "00:00:00";
			this.duration = 0;
			this.durationPretty = "00:00:00";
			this.progress = 0;
			//this.state = "disconnected";
			// This part is the reason why people love this library ❤️
			if (this.subtitles.length) {
				// I'm using the Netflix subtitle styling
				// chrome.cast.media.TextTrackFontGenericFamily.CASUAL
				// chrome.cast.media.TextTrackEdgeType.DROP_SHADOW
				mediaInfo.textTrackStyle = new chrome.cast.media.TextTrackStyle();
				mediaInfo.textTrackStyle.backgroundColor = "#00000000";
				mediaInfo.textTrackStyle.edgeColor = "#00000016";
				mediaInfo.textTrackStyle.edgeType = "DROP_SHADOW";
				mediaInfo.textTrackStyle.fontFamily = "CASUAL";
				mediaInfo.textTrackStyle.fontScale = 1.0;
				mediaInfo.textTrackStyle.foregroundColor = "#FFFFFF";

				var tracks = [];
				for (var i in this.subtitles) {
					// chrome.cast.media.TrackType.TEXT
					// chrome.cast.media.TextTrackType.CAPTIONS
					var track = new chrome.cast.media.Track(i, "TEXT");
					track.name = this.subtitles[i].label;
					track.subtype = "CAPTIONS";
					track.trackContentId = this.subtitles[i].src;
					track.trackContentType = "text/vtt";
					// This bug made me question life for a while
					track.trackId = parseInt(i);
					tracks.push(track);
				}
				mediaInfo.tracks = tracks;
			}
			// Let's prepare the metadata
			mediaInfo.metadata.images = [new chrome.cast.Image(this.poster)];
			mediaInfo.metadata.title = this.title;
			mediaInfo.metadata.subtitle = this.description;
			mediaInfo.customData = { licenseHeader: this.customData };
			// Prepare the actual request
			var request = new chrome.cast.media.LoadRequest(mediaInfo);
			cast.framework.CastContext.getInstance()
				.getCurrentSession()
				.loadMedia(request)
				.then(
					() => {
						// Update device name
						this.device =
							cast.framework.CastContext.getInstance()
								.getCurrentSession()
								.getCastDevice().friendlyName || this.device;
						return this;
					},
					(err) => {
						return this.trigger("error", err);
					}
				);
		},
		isPlatformMobile() {
			let check = false;
			(function (a) {
				if (
					/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
						a
					) ||
					/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
						a.substr(0, 4)
					)
				)
					check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);

			return check;
		},
		isPlatformTablet() {
			return (function (a) {
				if (/ipad|android.+\d safari|tablet/i.test(a)) return true;
			})(navigator.userAgent || navigator.vendor || window.opera)
				? "true"
				: "false";
		},

		handleFullscreenOrientation(event) {
			if (this.player) {
				const fullscreenOrNot = this.player.isFullscreen();
				if (this.isPlatformMobile()) {
					if (fullscreenOrNot && screen.orientation) {
						screen.orientation.lock("landscape");
					}
					else if (screen.orientation) {
						screen.orientation.lock("portrait");
					}
				}
			}


		},
		ShowCastNotification() {
			if (this.isPlatformMobile() == true) {
				this.$store.commit(
					"setNotification",
					"Please download Ibakatv Mobile App to cast your device"
				);
			} else if (this.isPlatformTablet() == true) {
				this.$store.commit(
					"setNotification",
					"Please download Ibakatv Mobile App to cast your device"
				);
			} else {
				this.$store.commit(
					"setNotification",
					"Please use Google Chrome browser to cast"
				);
			}
		},
	},
	beforeDestroy() {
		document.removeEventListener("fullscreenchange", this.handleFullscreenOrientation);
		location.reload();
	},
};
</script>
<style  scoped lang="scss">
.safari-player {
	width: 100vw;
	height: 100vh;
}

.list-item .image-bg {
	transform: scale(1);
}

.list-item:hover .image-bg {
	transform: scale(1.2);
	transition: all 0.5s ease;
}

.vjs-button>.vjs-icon-placeholder:before {
	font-size: 2.8em !important;
	line-height: unset !important;
}

.vjs-button>.vjs-icon-placeholder:hover {
	color: #85b157 !important;
}

.video-js .vjs-volume-panel .vjs-volume-control {
	color: #85b157 !important;
}

.video-js .vjs-play-progress {
	background-color: #85b157 !important;
}

.video-js .vjs-big-play-button {
	position: absolute !important;
	top: 42% !important;
	left: 45% !important;
}

.video-js .vjs-big-play-button {
	width: 80px !important;
	height: 80px !important;
	background-color: #85b157 !important;
	border-color: transparent !important;
	border-radius: 50% !important;
	font-size: 50px !important;
}

.video-js .vjs-volume-level {
	background-color: #85b157 !important;
}

.video-js .vjs-play-progress:before {
	color: #85b157 !important;
}

.backBtn {
	position: fixed;
	transform: translate(60%, 150%);
	z-index: 200;
	color: white !important;
	background-color: none;
	cursor: pointer;
	background: transparent;
	display: flex !important;
	justify-content: center !important;
	width: 27px;
	margin-top: 10px;
}

.cast-btn {
	position: absolute;
	right: 50px;
	transform: translate(60%, 150%);
	z-index: 200;
	color: white !important;
	background-color: none;
	cursor: pointer;
	background: transparent;
	width: 27px;
	margin-top: 10px;

	&:hover {
		color: #85b157 !important;
	}
}
</style>
